/**
 * Services tour — 4 steps.
 *
 * target   = CSS selector for data-tour="X" attribute on the DOM node.
 * path     = route path to navigate to before measuring target.
 * i18n keys live under tours.services.*
 *
 * Shared shape with Admin-App/src/guidedTour/tours/servicesTour.js
 * (mobile uses refs via useTourTarget for `target` — same id, different
 * lookup mechanism).
 */
export default {
  id: "services",
  i18nTitle: "tours.services.title",
  steps: [
    {
      id: "services.welcome",
      target: null,
      path: "/appointments",
      i18nBody: "tours.services.step1.body",
    },
    {
      id: "services.tab",
      target: "my-business-link",
      path: "/appointments",
      i18nBody: "tours.services.step2.body",
    },
    {
      id: "services.fab",
      target: "services-fab",
      path: "/services",
      i18nBody: "tours.services.step3.body",
      hint: "tours.services.step3.hint",
    },
    {
      // Highlight the whole form card so the user sees every field
      // in scope, then read the body for the call to action.
      id: "services.form",
      target: "service-form",
      path: "/services/create",
      i18nBody: "tours.services.step4.body",
    },
  ],
};
